<div class="">
    <span>{{ TitlePage }} </span>
    <div class="row card" style="
    padding-bottom: 0px;border-bottom: 0px;
">
        <div class="bar-title" style=" text-align: center;border: 1px solid;"><b
                style="font-size: 22px;text-transform:uppercase;">Informaci&oacute;n del asociado</b></div>

        <div class="text-introd">
            A continuaci&oacute;n ingrese los datos de la cuenta que desea
            matricular para el d&eacute;bito autom&aacute;tico de su estado de cuenta Coomeva.
        </div>


        <div style="padding-top: 30px;">
            <div class="col-6">

                <s-input class="col-8 col-sm-6 padding-right" [skeleton]="FieldNumberId" #InputNumberId></s-input>

                <s-input class="col-8 col-sm-6 padding-right" [skeleton]="FieldNames" #InputNames></s-input>

                <s-input class="col-8 col-sm-6 padding-right" [skeleton]="FieldEmail" #InputEmail></s-input>


                <div class="col-8 col-sm-6 padding-left">
                    <form class="padding-right">
                        <fieldset>
                            <div class="form-group">
                                <label>
                                    <i class="input-required-symbol">*</i>
                                    Banco
                                </label>
                                <div class="s-combobox-flex">
                                    <select [(ngModel)]="cuentaMatricula.codigoBanco"
                                        [ngModelOptions]="{ standalone: true }"
                                        class="combo form-control fas fa-caret-down">
                                        <option class="s-combobox-row" value="">-</option>
                                        <option *ngFor="let item of bancoList; index as i" [value]="item.valor"
                                            [ngClass]="'s-combobox-row'">{{ item.descripcion }}</option>
                                    </select>
                                   
                                </div>
                                <div class="input-required-text"></div>
                            </div>
                        </fieldset>
                    </form>
                </div>

                <div class="col-8 col-sm-6 alignCombo">
                    <form class="padding-right">
                        <fieldset>
                            <div class="form-group">
                                <label>
                                    <i class="input-required-symbol">*</i>
                                    Tipo Cuenta
                                </label>
                                <div class="s-combobox-flex">
                                    <select [(ngModel)]="cuentaMatricula.tipoCuenta"
                                        [ngModelOptions]="{ standalone: true }"
                                        class="combo form-control fas fa-caret-down">
                                        <option class="s-combobox-row" value="">-</option>
                                        <option *ngFor="let item of tipoCuentaList; index as i" [value]="item.valor"
                                            [ngClass]="'s-combobox-row'">{{ item.descripcion }}</option>
                                    </select>
                                </div>
                                
                               
                                <div class="input-required-text"></div>

                            </div>
                        </fieldset>
                    </form>
                </div>

                <s-input class="col-8 col-sm-6 alignCuenta" [skeleton]="FieldCuenta" #InputCuenta></s-input>
               
               
                
                
            
            </div>
            <div class="select-required-cedula-asesor">
                <div class="preg">
                    <i class="input-required-symbol">*</i>
                    <p>¿Tuviste ayuda de un Asesor?</p>
                </div>
                
                <br>
                  <select class="select-asesor"  (change)="Mostrar()"  >
                    
                    <option  >no</option>
                    <option  value="1">si</option>

                  </select>
              
                  <div class="input-required-cedula-asesor" *ngIf="mostrar" 
                  >
                     <input type="number" name="" [(ngModel)]="cuentaMatricula.numeroDeCedulaAsesor"  (cut)="(false)" (copy)="(false)" (paste)="(false)"><p> ingresa el número de Cédula del Asesor</p>
                     <input class="select-cedulaAs-2" type="number" name="" [(ngModel)]="validador"(cut)="(false)" (copy)="(false)" (paste)="(false)"><p>Confirme el número de Cédula del Asesor</p>
                  </div>

            </div>
            
        </div>


        

    </div>

    <div class="text-record">
            <b>Recomendaci&oacute;n:</b> Con sus aportes mantenemos viva la fuerza de la cooperaci&oacute;n,
            recuerde mantener saldo en su cuenta 
            inscrita cada mes para hacer efectivo el d&eacute;bito de su estado de cuenta.
        </div>

    <div class="buttons-center text-button">
        <button class="btn btn-icon btn-default" (click)="clickConfirm()">
            Guardar
        </button>

        <button class="btn btn-icon btn-default" (click)="OnExitSeccion()">
            Salir
        </button>

    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/pages/home/inicio.component.html